import { render, staticRenderFns } from "./cell-item.vue?vue&type=template&id=3bd5277c&scoped=true&"
import script from "./cell-item.vue?vue&type=script&lang=ts&"
export * from "./cell-item.vue?vue&type=script&lang=ts&"
import style0 from "./cell-item.vue?vue&type=style&index=0&id=3bd5277c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd5277c",
  null
  
)

export default component.exports